/* ═══════════════════════════════════════════════════════════════════
   DICE THRONE — L'ARENA
   Selettore scontro + pronostico matchup + add-to-cart doppio.

   I dati eroe (voce, motore, frammenti matchup) stanno qui.
   I dati commerciali (prezzo, disponibilità, immagine, url) arrivano
   dal Liquid via <script id="dt-products" type="application/json">.
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────
     1. GLI EROI
     clock  = velocità con cui l'eroe chiude la partita (1 lento → 5 fulmineo)
     arch   = archetipo, usato per comporre i pronostici non scritti a mano
     ───────────────────────────────────────────────────────────────── */

  var HEROES = {
    'barbarian': {
      name: 'Barbarian',
      epithet: 'Nessun trucco. Solo colpi.',
      complexity: 1,
      clock: 5,
      arch: 'tempo',
      engine: 'Nessuno. È l\'unico eroe che non costruisce niente.',
      threats: ['Stun', 'Concussion'],
      story: 'Non ha un piano. Ha un martello e la certezza di arrivare per primo. Mentre gli altri accumulano risorse, girano dial e preparano combo, lui ha già colpito tre volte. Ogni tuo turno perso a costruire è un turno in cui lui ti sta addosso.',
      feel: 'Immediato. Tiri, colpisci, ridi. Zero gestione.',
      forYou: 'vuoi imparare in cinque minuti e menare subito',
      notForYou: 'ti diverte tessere piani lunghi',
      // frammenti per i pronostici composti
      youAre: 'Non costruisci niente, e proprio per questo sei avanti dal primo turno. Stun toglie il turno, Concussion toglie efficacia: ogni turno che rubi è un turno in cui il tuo avversario non monta la sua macchina.',
      youWin: 'Non rallentare mai. Se la partita dura, perdi: chiudi entro il turno otto.',
      youFear: 'chi ti sopravvive. Non hai un piano B.',
      threat: 'ti stordisce prima che tu sia pronto, e non ti dà il tempo di rialzarti.'
    },

    'moon-elf': {
      name: 'Moon Elf',
      epithet: 'Non ti schiva. Ti fa sbagliare.',
      complexity: 2,
      clock: 3,
      arch: 'negazione',
      engine: 'Nessuna risorsa da accumulare: manipola i dadi, i tuoi e i suoi.',
      threats: ['Blind', 'Entangle', 'Evasive', 'Targeted'],
      story: 'Colpisce poco e non ne ha bisogno. Blind ti fa fallire le abilità, Entangle ti toglie forza, e quando finalmente becchi il colpo buono lei è Evasive e sparisce. È l\'eroe che ti fa perdere la calma senza aver mai alzato la voce.',
      feel: 'Chirurgico. Vinci gestendo la frustrazione altrui.',
      forYou: 'vuoi qualcosa di semplice ma non stupido',
      notForYou: 'ti servono numeri grossi per divertirti',
      youAre: 'Non fai male: fai fallire. Blind spegne le abilità, Entangle taglia la forza, Evasive ti sottrae al colpo grosso. L\'avversario non perde vita — perde turni.',
      youWin: 'Nega i due turni chiave, poi chiudi con Lunar Eclipse quando lui non ha più risposte.',
      youFear: 'chi non dipende dai dadi per funzionare.',
      threat: 'ti accieca e ti impiglia: i tuoi tiri migliori non attivano niente.'
    },

    'pyromancer': {
      name: 'Pyromancer',
      epithet: 'Ogni turno brucia più forte.',
      complexity: 3,
      clock: 2,
      arch: 'escalation',
      engine: 'Fire Mastery: si accumula fino a 5 e potenzia tutto.',
      threats: ['Burn', 'Knockdown', 'Stun'],
      story: 'Parte piano e finisce devastante. Fire Mastery sale turno dopo turno e ogni punto rende ogni colpo peggiore del precedente. Il problema è arrivarci: nei primi turni è fragile, e chi la conosce prova a chiuderla prima che il fuoco prenda.',
      feel: 'Una miccia. Trattieni, trattieni, poi il tavolo esplode.',
      forYou: 'ti piace costruire verso un finale spettacolare',
      notForYou: 'non hai la pazienza dei primi tre turni',
      youAre: 'Fire Mastery sale fino a 5 e ogni punto rende il colpo successivo peggiore. Burn continua a mordere anche nei turni in cui non attacchi, e Knockdown gli toglie il turno proprio mentre stai caricando.',
      youWin: 'Sopravvivi ai primi tre turni. Da Fire Mastery 4 in poi non c\'è recupero possibile.',
      youFear: 'chi ti aggredisce subito, prima che il fuoco prenda.',
      threat: 'ti stordisce e ti brucia, e ogni turno che passa colpisce più forte del precedente.'
    },

    'shadow-thief': {
      name: 'Shadow Thief',
      epithet: 'Il colpo che non hai visto.',
      complexity: 5,
      clock: 3,
      arch: 'logoramento',
      engine: 'Shadows: esci dal bersaglio. Poison lavora mentre non ci sei.',
      threats: ['Poison', 'Sneak Attack', 'Shadows'],
      story: 'Non ti affronta mai davvero. Entra nelle Shadows ed evita il danno del tutto, mentre il Poison che ti ha lasciato addosso continua a lavorare da solo. Quando riappare è per un Sneak Attack, e a quel punto sei già a metà vita senza sapere quando è successo.',
      feel: 'Sgusciante e cattivo. Vinci non essendoci.',
      forYou: 'ti diverte far innervosire chi hai davanti',
      notForYou: 'vuoi uno scontro frontale e leggibile',
      youAre: 'Non incassi: sparisci. Le Shadows annullano il danno per intero, e intanto il Poison che hai lasciato addosso continua a lavorare da solo, turno dopo turno, senza che tu debba fare niente.',
      youWin: 'Veleno presto, ombre sui turni pesanti, e chiudi prima che l\'avversario trovi il ritmo.',
      youFear: 'la pressione costante che non ti lascia respirare tra un\'ombra e l\'altra.',
      threat: 'sparisce quando colpisci e ti avvelena quando non guardi.'
    },

    'duelist': {
      name: 'Duelist',
      epithet: 'Balla lui. Tu lo segui.',
      complexity: 3,
      clock: 4,
      arch: 'tempo',
      engine: 'Footwork Track: avanza e arretra, e decide il ritmo dello scontro.',
      threats: ['Guard Break', 'Disarm'],
      story: 'Il combattimento è la sua arte e si vede. Il Footwork Track lo fa scivolare avanti e indietro lungo la traccia: avanza per colpire più duro, arretra per non farsi prendere. Guard Break passa attraverso le difese, Disarm ti lascia sbilanciato. Non è forza — è coreografia.',
      feel: 'Tecnico e compiaciuto. Ogni turno è una scelta di posizione.',
      forYou: 'ti piace il controllo fine, non la potenza bruta',
      notForYou: 'non vuoi pensare a dove ti trovi ogni turno',
      youAre: 'Il Footwork Track è il tuo vero vantaggio: decidi tu quando essere aggressivo e quando sparire dal raggio. Guard Break passa attraverso qualsiasi difesa, Disarm gli toglie il ritmo appena l\'ha trovato.',
      youWin: 'Controlla la traccia. Chi detta il tempo in questo gioco ha già vinto metà partita.',
      youFear: 'chi ti costringe a difendere e ti toglie la libertà di muoverti.',
      threat: 'ti passa attraverso la guardia e ti disarma quando avevi appena preso il ritmo.'
    },

    'forgemaster': {
      name: 'Forgemaster',
      epithet: 'Prima l\'armatura. Poi il resto.',
      complexity: 4,
      clock: 2,
      arch: 'costruzione',
      engine: 'Estrae Ore dal proprio mazzo e forgia Elmi e Scudi: Oro → Diamante → Ultranium.',
      threats: ['Armor'],
      story: 'L\'unico eroe che gioca contro il tuo mazzo prima che contro di te. Scava Ore, le trasforma in Elmi e Scudi, e ogni pezzo forgiato è danno che non subirà mai. Chi non riesce a rompere l\'armatura entro il turno sei si ritrova a picchiare un muro che intanto ha imparato a colpire.',
      feel: 'Soddisfacente come un mestiere. Ogni turno costruisci qualcosa.',
      forYou: 'ti piace vedere una macchina crescere sotto le mani',
      notForYou: 'vuoi risultati immediati',
      youAre: 'Ogni Ore che estrai diventa un pezzo di armatura, e ogni pezzo è danno che non subirai mai. Non devi vincere in fretta: devi solo diventare impossibile da scalfire prima che l\'avversario ci riesca.',
      youWin: 'Arriva a Diamante entro il turno sei. Da lì in poi la partita si decide su chi resiste, e resisti tu.',
      youFear: 'chi ti aggredisce mentre sei ancora in mutande, nei primi due turni.',
      threat: 'diventa ogni turno più duro da scalfire, finché i tuoi colpi non contano più niente.'
    },

    'raveness': {
      name: 'Raveness',
      epithet: 'Non ti batte. Ti consuma.',
      complexity: 3,
      clock: 2,
      arch: 'negazione',
      engine: 'Nevermore, il corvo con dial proprio, che vola sull\'avversario e riporta indietro vita e risorse.',
      threats: ['Hex', 'Feather'],
      story: 'Manda il corvo, e il corvo torna con qualcosa di tuo. Vita, risorse, non importa: quello che perdi tu lo guadagna lei. Hex ti oscura la fortuna zittendo i sei fino a fine turno. Non vince per potenza — vince per decadenza elegante.',
      feel: 'Paziente e un po\' viscido. Metti un pezzo alla volta, poi il tavolo si gira.',
      forYou: 'vuoi vincere di logica e goderti l\'agonia altrui',
      notForYou: 'ti serve vedere numeri grossi subito',
      youAre: 'Nevermore vola, prende, e torna. Quello che l\'avversario perde tu lo guadagni: è un travaso continuo che non si vede finché non è troppo tardi. Hex gli zittisce i sei, e senza sei metà delle sue abilità non partono.',
      youWin: 'Non correre. Ogni turno di travaso allarga il divario: lascia che sia lui a doverti rincorrere.',
      youFear: 'chi ti uccide prima che il corvo abbia fatto abbastanza viaggi.',
      threat: 'ti ruba addosso quello che costruisci e ti zittisce i sei quando servono.'
    },

    'necromancer': {
      name: 'Necromancer',
      epithet: 'Non combatte lui. Manda gli altri.',
      complexity: 6,
      clock: 1,
      arch: 'costruzione',
      engine: 'Corpse Dial: raccoglie "pezzi di ricambio" e li spende per schierare non-morti.',
      threats: ['Decrep-ify', 'Resurrect'],
      story: 'L\'eroe più complesso della linea, e il più cattivo se lo lasci lavorare. Accumula Corpse sul dial e li converte in scheletri, maghi e golem che combattono al posto suo. Decrep-ify ti limita i rilanci, Resurrect lo riporta indietro quando lo credevi morto. Non lo batti: devi seppellirlo due volte.',
      feel: 'Un motore vero. Sei turni di setup, poi non c\'è più partita.',
      forYou: 'vuoi la sfida più tosta che Dice Throne offre',
      notForYou: 'è il tuo primo eroe — davvero, non partire da qui',
      youAre: 'Il Corpse Dial è una banca. Ogni turno versi, e quando prelevi esce un\'armata che combatte al posto tuo. Decrep-ify gli taglia i rilanci, e Resurrect ti riporta indietro proprio quando pensava di avercela fatta.',
      youWin: 'Sopravvivi fino al turno sei con il dial pieno. Da lì la partita si gioca da sola.',
      youFear: 'l\'aggressione precoce: sei carta velina finché l\'armata non è in piedi.',
      threat: 'ti riempie il tavolo di non-morti e ti toglie i rilanci quando ti servono.'
    },

    'pale-lady': {
      name: 'Pale Lady',
      epithet: 'Poi la luna sale.',
      complexity: 3,
      clock: 3,
      arch: 'trasformazione',
      engine: 'Moon Shard: raccogli frammenti, gira la plancia, diventi licantropo. E non torni indietro finché la luna non cala.',
      threats: ['Bleed', 'Prey'],
      story: 'Di giorno è una bellezza del sud, tutta grazia. Poi raccoglie abbastanza Moon Shard, la plancia si gira fisicamente e diventa un predatore. In forma di lupo colpisce come nessun altro — ma non può tornare umana a comando. Se sbagli il momento della trasformazione, sei bloccata nella furia mentre lui recupera.',
      feel: 'Due giochi in uno. E il momento del salto è tutto.',
      forYou: 'ami i personaggi che cambiano forma a metà partita',
      notForYou: 'vuoi sapere sempre cosa fai il turno dopo',
      youAre: 'Raccogli Moon Shard e giri la plancia: in forma di lupo il tuo danno non ha paragoni sul tavolo. Bleed continua a lavorare, Prey segna la vittima. Ma la finestra è quella, e va usata tutta.',
      youWin: 'Trasformati un turno prima di quanto ti sembri prudente, e non sprecare nemmeno un turno da lupo.',
      youFear: 'chi ti costringe a trasformarti troppo presto, o ti aspetta fuori dalla finestra.',
      threat: 'a metà partita cambia forma e il suo danno raddoppia di colpo.'
    },

    'sun-elf': {
      name: 'Sun Elf',
      epithet: 'Alba, tramonto, alba.',
      complexity: 3,
      clock: 3,
      arch: 'ciclo',
      engine: 'Sun Dial: sale fino all\'Alba dove tutto si amplifica, poi cade al Tramonto e si spegne. E ricomincia.',
      threats: ['Sun Marked', 'Charged Gem'],
      story: 'La sua forza non è costante: è un\'onda. Il Sun Dial sale verso l\'Alba e ogni suo colpo si accende, poi precipita al Tramonto e per un paio di turni è quasi inoffensiva. Giocarla bene significa una cosa sola: far coincidere l\'Alba con il momento in cui serve.',
      feel: 'Ritmico. Impari a leggere l\'onda e a cavalcarla.',
      forYou: 'ti piacciono le finestre di potenza da programmare',
      notForYou: 'vuoi la stessa forza tutti i turni',
      youAre: 'Il Sun Dial è la tua onda. All\'Alba ogni colpo si amplifica e Charged Gem li rende precisi; al Tramonto incassi e ricarichi. Sun Marked ti restituisce energia e vita mentre segni chi hai davanti.',
      youWin: 'Fai coincidere l\'Alba con il suo turno peggiore. È tutto lì.',
      youFear: 'chi ti aggredisce durante il Tramonto, quando non hai risposte.',
      threat: 'ha finestre in cui colpisce il doppio, e sa farle capitare nel momento sbagliato per te.'
    },

    'headless-horseman': {
      name: 'Headless Horseman',
      epithet: 'Lo senti arrivare. Non serve a niente.',
      complexity: 4,
      clock: 4,
      arch: 'tempo',
      engine: 'Haunted Head e token Dreadful, che alimentano Grim Pursuit: tiri extra o danno amplificato.',
      threats: ['Dreadful', 'Grim Pursuit'],
      story: 'Cavalca senza testa e usa la tua paura come arma. La zucca affligge di terrore, i Dreadful lo potenziano, e Grim Pursuit gli regala tiri in più — che in un gioco di dadi significa semplicemente avere più partita degli altri. Aggressivo e con un motore sotto: raro.',
      feel: 'Pressione continua che cresce. Non ti lascia mai fermo.',
      forYou: 'vuoi aggredire ma senza rinunciare a un motore',
      notForYou: 'preferisci difendere e reagire',
      youAre: 'Grim Pursuit ti dà tiri extra, e in un gioco di dadi più tiri significa più partita. I Dreadful si accumulano mentre attacchi, quindi non devi scegliere tra costruire e aggredire: fai entrambe le cose insieme.',
      youWin: 'Non mollare la pressione. Il tuo motore gira mentre attacchi, il suo no.',
      youFear: 'chi regge l\'urto iniziale e ti costringe a giocare di rimessa.',
      threat: 'tira più dadi di te e intanto accumula terrore: attacca e costruisce nello stesso turno.'
    },

    'druid': {
      name: 'Druid',
      epithet: 'Gatto quando serve. Orso quando conviene.',
      complexity: 4,
      clock: 3,
      arch: 'trasformazione',
      engine: 'Shape Shift: un overlay fisico sulla plancia commuta tra forma Gatto e forma Orso.',
      threats: ['Wounds', 'Thick Hide', 'Regenerate'],
      story: 'Non ha un piano fisso perché ne ha due. Gatto colpisce rapido e preciso lasciando Wounds; Orso si chiude nella Thick Hide e incassa. E quando non sta cambiando forma, Regenerate gli ricuce addosso i danni presi. È l\'eroe che ha sempre la risposta giusta — se sai qual è.',
      feel: 'Adattivo. Leggi il tavolo e cambi assetto.',
      forYou: 'ti piace reagire e non avere una linea sola',
      notForYou: 'vuoi un piano deciso a inizio partita',
      youAre: 'Hai due giochi e scegli quale usare ogni turno: Gatto per colpire preciso e lasciare Wounds, Orso per chiuderti nella Thick Hide. E Regenerate ti ricuce mentre gli altri consumano risorse per fare danno.',
      youWin: 'Cambia forma un turno prima di averne bisogno, non quando è già tardi.',
      youFear: 'la pressione che non ti lascia il tempo di scegliere la forma giusta.',
      threat: 'cambia assetto in base a cosa fai tu, e si cura mentre lo fa.'
    }
  };

  /* ─────────────────────────────────────────────────────────────────
     2. FASCE DI DIFFICOLTÀ
     ───────────────────────────────────────────────────────────────── */

  var TIERS = [
    { id: 't1', min: 1, max: 2, label: 'Siediti e picchia',
      blurb: 'Impari in cinque minuti. Nessuna risorsa da gestire, nessun dial da girare. Se è la tua prima volta a Dice Throne, parti da qui.' },
    { id: 't2', min: 3, max: 3, label: 'Hai un piano',
      blurb: 'Una risorsa da far crescere o una finestra da cogliere. Resta leggibile, ma le scelte iniziano a pesare davvero.' },
    { id: 't3', min: 4, max: 4, label: 'Guidi una macchina',
      blurb: 'Motori con più pezzi che vanno tenuti insieme. Le prime partite le sbagli, poi non torni più indietro.' },
    { id: 't4', min: 5, max: 6, label: 'Il tavolo è tuo, se sai tenerlo',
      blurb: 'Il vertice della linea. Setup lunghi, tanti stati sovrapposti, punizioni severe se sbagli l\'ordine. Non sono primi eroi.' }
  ];

  /* ─────────────────────────────────────────────────────────────────
     2bis. DUELLI PRONTI — coppie curate, acquisto in un click
     ───────────────────────────────────────────────────────────────── */

  var DUELS = [
    { id: 'primo', heroes: ['barbarian', 'moon-elf'],
      name: 'Il primo duello',
      for: 'Se non hai mai giocato',
      why: 'I due eroi più semplici della linea, e fanno cose opposte: lui picchia e basta, lei ti fa sbagliare. È l\'accoppiata con cui Dice Throne si è fatto conoscere, e resta il modo migliore per capirlo in una partita sola.' },

    { id: 'mostri', heroes: ['pale-lady', 'headless-horseman'],
      name: 'Notte di mostri',
      for: 'Se vuoi il colpo d\'occhio',
      why: 'Un licantropo che si trasforma girando fisicamente la plancia contro un cavaliere senza testa che tira più dadi di chiunque altro. Il tavolo più bello da vedere del catalogo.' },

    { id: 'fuoco', heroes: ['pyromancer', 'shadow-thief'],
      name: 'Fuoco e ombra',
      for: 'Se ti piace il rischio',
      why: 'Lei diventa più forte ogni turno, lui deve chiudere prima che accada. Venticinque minuti in cui nessuno dei due difende mai.' },

    { id: 'cantieri', heroes: ['forgemaster', 'necromancer'],
      name: 'I due cantieri',
      for: 'Se ami i motori',
      why: 'Uno forgia armature, l\'altro raccoglie cadaveri. Quaranta minuti di costruzione paziente prima che qualcuno tiri il primo colpo che conta davvero.' },

    { id: 'elfi', heroes: ['moon-elf', 'sun-elf'],
      name: 'La notte e il giorno',
      for: 'Se vuoi qualcosa di elegante',
      why: 'Poca violenza, molte scelte. Lei nega, lei cavalca un ciclo di alba e tramonto. Difficoltà 2 contro 3: si spiega in fretta e si gioca bene.' },

    { id: 'profondo', heroes: ['shadow-thief', 'necromancer'],
      name: 'Il salto nel profondo',
      for: 'Se Dice Throne lo conosci già',
      why: 'Difficoltà 5 contro 6, i due eroi più tecnici della linea. Non è un primo acquisto: è un traguardo.' }
  ];

  /* ─────────────────────────────────────────────────────────────────
     3. PRONOSTICI SCRITTI A MANO
     chiave: le due slug in ordine alfabetico, unite da "|"
     ───────────────────────────────────────────────────────────────── */

  var MATCHUPS = {
    'barbarian|moon-elf': {
      title: 'La forza contro la calma',
      fav: 'moon-elf',
      favWhy: 'Moon Elf, ma di pochissimo: se il Barbarian trova due Stun di fila la partita finisce prima che lei possa fare qualcosa.',
      a: { fear: 'Blind. Il tuo colpo grosso non parte proprio, e tu non hai un secondo piano.', win: 'Non cercare il colpo perfetto: cerca lo Stun. Un\'elfa che non gioca non può accecarti.' },
      b: { fear: 'la velocità. Non hai il tempo di impostare niente, lui è già addosso al secondo turno.', win: 'Accecalo sul suo turno migliore e sopravvivi. Al turno sei ha finito le idee e tu no.' },
      turn: 'Il primo Blind riuscito. Se arriva entro il turno tre, la partita si ribalta.',
      tempo: 'Nervoso e breve. Uno corre, l\'altra frena. 20 minuti.',
      note: 'È lo scontro d\'esordio storico di Dice Throne, ed è ancora il migliore per capire il gioco: due eroi semplici che fanno cose opposte.'
    },

    'pyromancer|shadow-thief': {
      title: 'La corsa contro il veleno',
      fav: 'shadow-thief',
      favWhy: 'Shadow Thief, ma solo per i primi tre turni.',
      a: { fear: 'le Shadows. Lui sparisce e il tuo colpo grosso va a vuoto proprio quando eri carica.', win: 'Non aspettare di essere al massimo. Brucialo mentre si nasconde: il Burn continua a mordere anche quando lui non c\'è.' },
      b: { fear: 'il Burn. Il veleno non ferma il fuoco, e se la partita va lunga lei ti supera.', win: 'Sneak Attack presto, veleno subito, e chiudi entro il turno sette. Dopo, il tavolo è suo.' },
      turn: 'Il turno in cui il Fire Mastery arriva a 4. Se Shadow Thief non è già avanti di 15 punti vita, ha perso.',
      tempo: 'Veloce e crudele. Nessuno dei due difende. 25 minuti.'
    },

    'barbarian|necromancer': {
      title: 'Arriva prima della prima pala',
      fav: 'barbarian',
      favWhy: 'Barbarian, nettamente. È lo scontro peggiore che il Necromancer possa pescare.',
      a: { fear: 'niente, nei primi cinque turni. Dopo, tutto.', win: 'Colpisci e non fermarti. Non stai giocando contro di lui: stai correndo contro il suo dial.' },
      b: { fear: 'esattamente questo. Sei carta velina finché l\'armata non è in piedi, e lui non te lo permette.', win: 'Decrep-ify sul suo turno migliore, incassa, e prega di arrivare al turno sei. Se ci arrivi, vinci.' },
      turn: 'Il turno cinque. È la linea: prima è sua, dopo è del Necromancer.',
      tempo: 'Un assedio al contrario. 30 minuti, decisi nei primi dieci.',
      note: 'Complexity 1 contro complexity 6, e vince spesso il più semplice. È il modo migliore per capire che in Dice Throne "complesso" non significa "forte".'
    },

    'barbarian|forgemaster': {
      title: 'Il martello e il muro',
      fav: 'forgemaster',
      favWhy: 'Forgemaster, se sopravvive ai primi due turni. È un\'ipotesi grossa.',
      a: { fear: 'l\'armatura. Arriva il momento in cui i tuoi colpi non fanno più niente e tu non hai altro.', win: 'Tutto nei primi tre turni. Colpiscilo mentre è ancora in mutande, perché dopo il Diamante non lo scalfisci più.' },
      b: { fear: 'la fretta. Ti serve tempo per forgiare e lui non te ne dà.', win: 'Sopravvivi. Ogni pezzo che forgi è un colpo che non conterà mai, e lui non ha un piano B.' },
      turn: 'Il primo Scudo di Diamante. Se il Barbarian non è già avanti, ha finito le opzioni.',
      tempo: 'Furia contro pazienza. Corto se sbaglia il fabbro, lungo se sbaglia il barbaro.'
    },

    'necromancer|raveness': {
      title: 'Due che rubano dallo stesso piatto',
      fav: 'raveness',
      favWhy: 'Raveness. Il suo travaso è più veloce del cimitero di lui.',
      a: { fear: 'Hex. Ti zittisce i sei proprio nei turni in cui devi riempire il Corpse Dial.', win: 'Ignora il corvo e scava. Se arrivi all\'armata, il travaso di lei non basta più.' },
      b: { fear: 'il turno sei. Prima di allora sei favorita, dopo hai un\'armata in faccia.', win: 'Manda Nevermore sul dial, non sulla vita. Ogni Corpse che non raccoglie è un non-morto che non vedrai.' },
      turn: 'Il turno in cui il Corpse Dial supera metà. Da lì la fretta cambia lato.',
      tempo: 'Lento, cattivo, pieno di componenti sul tavolo. 40 minuti buoni.',
      note: 'Lo scontro più "brutto da guardare e bello da giocare" della linea: due motori che si sabotano a vicenda.'
    },

    'druid|pale-lady': {
      title: 'Due bestie, due modi di diventarlo',
      fav: 'druid',
      favWhy: 'Druid, perché può cambiare idea. Lei no.',
      a: { fear: 'la finestra da lupo. Se ti prende in forma Gatto durante la sua trasformazione, non incassi abbastanza.', win: 'Passa a Orso un turno prima che si trasformi. Thick Hide spegne la sua finestra, e la finestra è tutto quello che ha.' },
      b: { fear: 'la Thick Hide. Ti trasformi, colpisci il doppio, e non basta comunque.', win: 'Trasformati presto e costringilo a stare Orso. Un Druid bloccato in difesa non ti fa niente.' },
      turn: 'Il turno della trasformazione. Chi la anticipa all\'altro vince.',
      tempo: 'Due partite in una. Prima si studiano, poi si sbranano. 35 minuti.',
      note: 'Il matchup più tematico del catalogo: entrambi girano fisicamente qualcosa sulla plancia.'
    },

    'moon-elf|sun-elf': {
      title: 'La notte contro il giorno',
      fav: 'moon-elf',
      favWhy: 'Moon Elf. La negazione batte il ciclo, perché il ciclo è prevedibile.',
      a: { fear: 'l\'Alba. Quando il Sun Dial è alto non ti basta accecarla una volta.', win: 'Studia il dial. Blind al momento dell\'Alba vale il triplo che al Tramonto.' },
      b: { fear: 'proprio questo: la tua onda si vede arrivare da lontano, e lei ti aspetta lì.', win: 'Sfasa il ritmo. Spendi carte per anticipare l\'Alba di un turno e trovala impreparata.' },
      turn: 'La prima Alba. Se passa senza fare danno, la Sun Elf ha perso il suo tempo migliore.',
      tempo: 'Elegante e pulito. Poco sangue, molte scelte. 30 minuti.',
      note: 'Complexity 2 contro 3, entrambe leggibili: se cercate lo scontro "bello da vedere" per far entrare qualcuno nel gioco, è questo.'
    },

    'forgemaster|pyromancer': {
      title: 'Il fuoco contro l\'incudine',
      fav: 'pyromancer',
      favWhy: 'Pyromancer, di misura. È l\'unica che sale più in fretta di quanto lui si copra.',
      a: { fear: 'il Burn. L\'armatura ferma i colpi, non il fuoco che hai già addosso.', win: 'Elmi prima degli Scudi e chiudi in fretta: contro di lei il tempo non è tuo alleato come al solito.' },
      b: { fear: 'l\'Ultranium. Se ci arriva, il tuo Fire Mastery 5 rimbalza.', win: 'Brucia presto e spesso. Il danno che scorre nel tempo ignora il muro che lui sta costruendo.' },
      turn: 'Il turno cinque: o l\'armatura è a Diamante, o il fuoco è a 4. Il primo dei due vince.',
      tempo: 'Una gara di costruzione. Chi finisce il motore per primo. 35 minuti.'
    },

    'headless-horseman|pale-lady': {
      title: 'La notte di due mostri',
      fav: 'headless-horseman',
      favWhy: 'Headless Horseman. Non le lascia il tempo di raccogliere i frammenti.',
      a: { fear: 'la finestra da lupo. Se arriva completa, il suo danno supera il tuo.', win: 'Pressione dal turno uno. Ogni Moon Shard che non raccoglie è una trasformazione rimandata.' },
      b: { fear: 'i tiri extra. Lui ha più partita di te ogni singolo turno.', win: 'Trasformati prima del solito, anche a metà frammenti. Contro di lui una finestra corta vale più di una perfetta che non arriva.' },
      turn: 'Il turno quattro. O la luna è salita, o non salirà in tempo.',
      tempo: 'Aggressivo e rumoroso. Nessuno difende. 25 minuti.',
      note: 'Se ne comprate due per Halloween, sono questi.'
    },

    'duelist|shadow-thief': {
      title: 'Due che non stanno mai dove guardi',
      fav: 'duelist',
      favWhy: 'Duelist. Guard Break è una delle poche risposte vere alle Shadows.',
      a: { fear: 'il Poison. Puoi controllare il tempo quanto vuoi, il veleno non guarda la traccia.', win: 'Guard Break sui turni in cui prova a sparire. Un ladro che non riesce a evitare il danno è solo un eroe fragile.' },
      b: { fear: 'esattamente Guard Break. È il colpo che passa dove tu contavi di non esserci.', win: 'Non giocare di ombre contro di lui: avvelena e corri. Il veleno lavora anche quando lui detta il tempo.' },
      turn: 'La prima Shadows bucata da Guard Break. Cambia tutto il piano del ladro.',
      tempo: 'Scherma vera. Finte, scarti, colpi improvvisi. 30 minuti.'
    },

    'barbarian|shadow-thief': {
      title: 'Colpire qualcuno che non c\'è',
      fav: 'shadow-thief',
      favWhy: 'Shadow Thief. È il peggior incubo del Barbarian: un bersaglio che sparisce.',
      a: { fear: 'le Shadows. Tutta la tua partita è colpire forte, e lui semplicemente non è lì.', win: 'Stun. Un ladro stordito non entra nell\'ombra, e quello è l\'unico turno in cui è tuo.' },
      b: { fear: 'lo Stun sul turno sbagliato. Se non entri nell\'ombra, incassi tutto in una volta.', win: 'Ombre sui suoi turni carichi, veleno su tutto il resto. Non serve altro.' },
      turn: 'Il primo Stun che becca il ladro fuori dall\'ombra. È l\'unica finestra del Barbarian.',
      tempo: 'Frustrante per uno, divertentissimo per l\'altro. 25 minuti.'
    },

    'necromancer|shadow-thief': {
      title: 'Chi sopravvive più a lungo a se stesso',
      fav: 'shadow-thief',
      favWhy: 'Shadow Thief. Il veleno non aspetta che l\'armata sia pronta.',
      a: { fear: 'il Poison. Ti serve tempo, e il veleno è precisamente la tassa sul tempo.', win: 'Decrep-ify presto per rallentare le sue combo, e non spendere Corpse in anticipo.' },
      b: { fear: 'l\'armata. Se ci arriva, le tue ombre non bastano più: sono troppi bersagli.', win: 'Avvelena e resta invisibile. Non devi ucciderlo, devi solo non lasciarlo arrivare al turno sei.' },
      turn: 'Il turno sei, come sempre col Necromancer. La domanda è solo se ci arriva.',
      tempo: 'Due complexity alte che si guardano male. 40 minuti, per chi sa cosa fa.',
      note: 'Complexity 6 contro 5: è lo scontro più tecnico che questa linea permetta. Non è un primo acquisto, è un traguardo.'
    },

    'pyromancer|raveness': {
      title: 'Chi spegne chi',
      fav: 'raveness',
      favWhy: 'Raveness. Hex arriva prima che il fuoco prenda.',
      a: { fear: 'Hex. Ti zittisce i sei proprio nei turni in cui devi salire di Fire Mastery.', win: 'Knockdown sul corvo che vola. Se le togli un viaggio di Nevermore, le togli il vantaggio.' },
      b: { fear: 'il Fire Mastery 5. Il tuo travaso è più lento della sua scalata, se la lasci arrivare.', win: 'Hex sui suoi turni di accumulo, non su quelli di attacco. Un fuoco che non sale è un fuoco morto.' },
      turn: 'Il terzo turno. Se il Fire Mastery è ancora a 1, Raveness ha già vinto.',
      tempo: 'Silenzioso e cattivo. Poca vita persa, tanto veleno psicologico. 35 minuti.'
    },

    'barbarian|druid': {
      title: 'La furia contro chi sa aspettarla',
      fav: 'druid',
      favWhy: 'Druid, se legge bene il momento. Se sbaglia forma anche una volta, no.',
      a: { fear: 'la Thick Hide. Ogni turno che lui incassa è un turno che tu non recuperi.', win: 'Concussion. Un Druid che non può cambiare forma efficacemente è metà eroe.' },
      b: { fear: 'lo Stun in forma Gatto. Sei fragile e non hai il turno per rimediare.', win: 'Orso appena parte, Regenerate mentre lui si sfoga, e Gatto quando ha finito le carte.' },
      turn: 'Il turno in cui il Barbarian finisce le carte in mano. Da lì è tutto del Druid.',
      tempo: 'Un\'onda contro uno scoglio. 30 minuti.'
    },

    'duelist|moon-elf': {
      title: 'Precisione contro precisione',
      fav: 'duelist',
      favWhy: 'Duelist. Il Footwork Track gli permette di non essere dove lei mira.',
      a: { fear: 'Blind. Anche il footwork perfetto non serve se l\'abilità non parte.', win: 'Arretra quando ti acceca, avanza quando ha finito i token. È letteralmente una danza.' },
      b: { fear: 'Guard Break. Le tue difese non sono difese contro di lui.', win: 'Entangle mentre è avanzato sulla traccia. Un Duelist che non può arretrare è scoperto.' },
      turn: 'Il primo Entangle su un Duelist in posizione avanzata.',
      tempo: 'Tecnico e sottile. Il più "da scacchisti" della linea. 30 minuti.'
    },

    'forgemaster|necromancer': {
      title: 'Due cantieri, una sola partita',
      fav: 'necromancer',
      favWhy: 'Necromancer. Se nessuno dei due aggredisce, vince chi ha il motore più grosso — e il suo lo è.',
      a: { fear: 'l\'armata. L\'armatura ferma un colpo grosso, non cinque piccoli.', win: 'Non aspettare l\'Ultranium: forgia il minimo e vai addosso al dial prima che si riempia.' },
      b: { fear: 'niente, se ti lascia costruire. Ed è esattamente quello che farà.', win: 'Scava tranquillo. È uno dei pochi avversari che non ti punisce per la lentezza.' },
      turn: 'Non c\'è un turno: c\'è una soglia. Chi finisce il motore per primo detta il finale.',
      tempo: 'Lento e cerebrale. Il più lungo della linea, 45 minuti. Non è per tutti.'
    },

    'headless-horseman|necromancer': {
      title: 'Il cavaliere non aspetta i morti',
      fav: 'headless-horseman',
      favWhy: 'Headless Horseman, con margine. I tiri extra battono il setup lungo.',
      a: { fear: 'il turno sei. Se ci arriva con il dial pieno, i tuoi tiri extra non bastano più.', win: 'Pressione costante. Il tuo motore gira mentre attacchi, il suo no: è tutto il vantaggio che ti serve.' },
      b: { fear: 'esattamente questo. Non hai un turno libero per scavare.', win: 'Decrep-ify sui suoi tiri extra: è l\'unico modo di togliergli il vantaggio strutturale.' },
      turn: 'Il turno quattro. Se il Corpse Dial è sotto metà, la partita è già decisa.',
      tempo: 'Uno insegue, l\'altro scava. 30 minuti.'
    },

    'pale-lady|shadow-thief': {
      title: 'Preda contro predatore, ma al contrario',
      fav: 'pale-lady',
      favWhy: 'Pale Lady. Prey è una delle poche cose che segue qualcuno dentro l\'ombra.',
      a: { fear: 'il veleno durante la raccolta. Ogni turno umano è un turno in cui perdi vita gratis.', win: 'Trasformati e usa Prey. Un ladro segnato non è più al sicuro nell\'ombra.' },
      b: { fear: 'la finestra da lupo. Le Shadows reggono un colpo, non tre.', win: 'Avvelenala mentre è ancora umana e sparisci durante la trasformazione. La finestra passa.' },
      turn: 'Il primo turno da lupo. O il ladro è già molto avanti, o è finita.',
      tempo: 'Un inseguimento vero. 30 minuti.'
    },

    'raveness|sun-elf': {
      title: 'Chi ruba la luce',
      fav: 'raveness',
      favWhy: 'Raveness. Il ciclo solare è prevedibile, e il corvo colpisce sempre nel punto giusto.',
      a: { fear: 'l\'Alba piena. Se ci arriva carica, un solo turno può ribaltare tutto il travaso.', win: 'Hex sull\'Alba, sempre. Un\'Alba senza sei è un turno sprecato per lei.' },
      b: { fear: 'Hex sul turno sbagliato. Perdi la finestra che stavi costruendo da tre turni.', win: 'Sfasa il dial di un turno con le carte. Se il corvo arriva al Tramonto, non ti ha tolto niente.' },
      turn: 'La seconda Alba. La prima è di studio, sulla seconda si decide.',
      tempo: 'Ritmato e pulito. 30 minuti.'
    },

    'barbarian|pyromancer': {
      title: 'Chi brucia per primo',
      fav: 'barbarian',
      favWhy: 'Barbarian, chiaramente. È il matchup peggiore per la Pyromancer.',
      a: { fear: 'niente, per tre turni. Poi tutto insieme.', win: 'Colpisci e basta. Ogni turno che le rubi è un punto di Fire Mastery che non salirà mai.' },
      b: { fear: 'esattamente questo: non hai i tre turni che ti servono.', win: 'Knockdown e Stun subito, non aspettare di essere carica. Devi comprarti il tempo, non il danno.' },
      turn: 'Il turno tre. Se il Fire Mastery è a 3, la Pyromancer ce l\'ha fatta. Se è a 1, no.',
      tempo: 'Corto e violento. 20 minuti.'
    },

    'druid|forgemaster': {
      title: 'Due modi di non morire',
      fav: 'druid',
      favWhy: 'Druid. Regenerate ripara, l\'armatura si consuma.',
      a: { fear: 'l\'Ultranium. C\'è un punto oltre il quale nemmeno il Gatto lo scalfisce.', win: 'Gatto costante e Wounds. Il danno che scorre nel tempo passa dove i colpi secchi non passano.' },
      b: { fear: 'Regenerate. Fai danno, lui se lo ricuce, e tu hai speso il turno.', win: 'Forgia veloce e colpisci in forma Gatto: è l\'unico momento in cui è fragile.' },
      turn: 'Il turno sette. Se nessuno dei due è sotto metà vita, la partita la vince chi si ripara, non chi si copre.',
      tempo: 'Lentissimo e paziente. Solo per chi ama la guerra di posizione. 45 minuti.'
    }
  };

  /* ─────────────────────────────────────────────────────────────────
     4. COMPOSITORE
     Per gli accoppiamenti non ancora scritti a mano, costruisce un
     pronostico partendo dai frammenti specifici dei due eroi.
     ───────────────────────────────────────────────────────────────── */

  var ARCH_TITLES = {
    'tempo|tempo': 'Corsa a chi chiude prima',
    'tempo|negazione': 'La fretta contro il freno',
    'tempo|costruzione': 'Arriva prima del cantiere',
    'tempo|escalation': 'Chi accende per primo',
    'tempo|trasformazione': 'Colpire prima del cambio',
    'tempo|ciclo': 'La fretta contro l\'onda',
    'negazione|negazione': 'Due che si spengono a vicenda',
    'negazione|costruzione': 'Sabotare il cantiere',
    'negazione|escalation': 'Spegnere la miccia',
    'negazione|trasformazione': 'Negare la finestra',
    'negazione|ciclo': 'Rubare il momento buono',
    'costruzione|costruzione': 'Due cantieri, una partita',
    'costruzione|escalation': 'Muro contro accensione',
    'costruzione|trasformazione': 'Il cantiere e la bestia',
    'costruzione|ciclo': 'Resistere all\'onda',
    'escalation|escalation': 'Chi sale più in fretta',
    'escalation|trasformazione': 'Due finestre, un tavolo',
    'escalation|ciclo': 'Due fuochi che non coincidono',
    'trasformazione|trasformazione': 'Due bestie',
    'trasformazione|ciclo': 'La bestia e l\'onda',
    'ciclo|ciclo': 'Due onde sfasate'
  };

  function archTitle(a, b) {
    var k = [a.arch, b.arch].sort().join('|');
    return ARCH_TITLES[k] || 'Scontro aperto';
  }

  function compose(sa, sb) {
    var a = HEROES[sa], b = HEROES[sb];
    var fav, favWhy;

    if (a.clock === b.clock) {
      fav = null;
      favWhy = 'Nessuno dei due. È uno scontro alla pari: decide chi commette il primo errore.';
    } else {
      var fastSlug = a.clock > b.clock ? sa : sb;
      var fastH = HEROES[fastSlug];
      var slowH = fastSlug === sa ? b : a;
      var gap = Math.abs(a.clock - b.clock);
      fav = fastSlug;
      favWhy = fastH.name + (gap >= 3
        ? ', con margine netto. ' + slowH.name + ' non ha il tempo che gli serve.'
        : ', di misura: chiude prima, ma senza margine per sbagliare.');
    }

    return {
      title: archTitle(a, b),
      fav: fav,
      favWhy: favWhy,
      a: { fear: b.threat, win: a.youWin },
      b: { fear: a.threat, win: b.youWin },
      turn: 'Il turno in cui ' + (a.clock >= b.clock ? b.name : a.name) + ' completa il proprio motore. Prima di quel momento la partita ha un padrone, dopo ne ha un altro.',
      tempo: tempoLabel(a, b),
      composed: true
    };
  }

  function tempoLabel(a, b) {
    var s = a.clock + b.clock;
    if (s >= 8) return 'Rapido e diretto. Nessuno dei due ha voglia di aspettare. Circa 20-25 minuti.';
    if (s >= 6) return 'Equilibrato: qualche turno di studio, poi si apre. Circa 30 minuti.';
    if (s >= 4) return 'Ragionato. Due motori che crescono prima di toccarsi. Circa 35-40 minuti.';
    return 'Lungo e cerebrale. Entrambi costruiscono a lungo prima di decidere. 45 minuti abbondanti.';
  }

  function getMatchup(sa, sb) {
    var key = [sa, sb].sort().join('|');
    var m = MATCHUPS[key];
    if (!m) return { data: compose(sa, sb), flip: false };
    // le voci a/b nei dati scritti a mano seguono l'ordine alfabetico della chiave
    var order = key.split('|');
    return { data: m, flip: order[0] !== sa };
  }

  /* ─────────────────────────────────────────────────────────────────
     5. APP
     ───────────────────────────────────────────────────────────────── */

  function init(root) {
    var dataEl = root.querySelector('[data-dt-products]');
    if (!dataEl) return;

    var PRODUCTS;
    try { PRODUCTS = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var slotA = null, slotB = null;
    var moneyFmt = root.getAttribute('data-money-format') || '{{amount}} €';

    var elRoster = root.querySelector('[data-dt-roster]');

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    /* ── selezione multipla (bundle costruito dall'utente) ─────── */
    var selected = [];
    var elBar = root.querySelector('[data-dt-bar]');
    var elDuels = root.querySelector('[data-dt-duels]');
    var elFilters = root.querySelector('[data-dt-filters]');
    var activeTier = 'all';

    function toggleSelect(slug) {
      var i = selected.indexOf(slug);
      if (i > -1) selected.splice(i, 1);
      else selected.push(slug);
      renderSelection();
    }

    function renderSelection() {
      root.querySelectorAll('[data-hero]').forEach(function (c) {
        var s = c.getAttribute('data-hero');
        var on = selected.indexOf(s) > -1;
        c.classList.toggle('is-selected', on);
        var b = c.querySelector('[data-select]');
        if (b) {
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.innerHTML = on ? '✓ Aggiunto' : '+ Aggiungi';
        }
      });
      renderBar();
    }

    function renderBar() {
      if (!elBar) return;
      // la classe sul contenitore serve al pulsante fisso per spostarsi
      root.classList.toggle('has-bar', selected.length > 0);
      if (!selected.length) { elBar.classList.remove('is-on'); elBar.innerHTML = ''; return; }

      var total = selected.reduce(function (t, s) { return t + ((PRODUCTS[s] || {}).price || 0); }, 0);
      var n = selected.length;

      var msg;
      if (n === 1) msg = '<b>1 eroe</b> selezionato — da solo non è giocabile, aggiungine un altro o usalo con quelli che hai già';
      else msg = '<b>' + n + ' eroi</b> selezionati — ' + (n === 2 ? 'una partita completa' : 'sono ' + (n * (n - 1) / 2) + ' scontri diversi');

      elBar.classList.add('is-on');
      elBar.innerHTML =
        '<div class="dt-bar__inner">' +
          '<div class="dt-bar__faces">' +
            selected.map(function (s) {
              var p = PRODUCTS[s] || {};
              return p.image
                ? '<img src="' + p.image + '" alt="' + HEROES[s].name + '" title="' + HEROES[s].name + '">'
                : '<span class="dt-bar__facePh">' + HEROES[s].name.charAt(0) + '</span>';
            }).join('') +
          '</div>' +
          '<div class="dt-bar__text"><p>' + msg + '</p><span class="dt-bar__total">' + money(total) + '</span></div>' +
          '<div class="dt-bar__acts">' +
            '<button type="button" class="dt-btn dt-btn--ghostSm" data-dt-clearsel>Svuota</button>' +
            '<button type="button" class="dt-btn dt-btn--buy dt-btn--barBuy" data-dt-addsel>Aggiungi al carrello</button>' +
          '</div>' +
        '</div>';
    }

    /* ── duelli pronti ─────────────────────────────────────────── */
    function renderDuels() {
      if (!elDuels) return;
      var html = '';
      DUELS.forEach(function (d) {
        var ok = d.heroes.every(function (s) { return (PRODUCTS[s] || {}).available !== false; });
        var total = d.heroes.reduce(function (t, s) { return t + ((PRODUCTS[s] || {}).price || 0); }, 0);

        html +=
        '<article class="dt-duel' + (ok ? '' : ' is-out') + '">' +
          '<div class="dt-duel__arts">' +
            d.heroes.map(function (s) {
              var p = PRODUCTS[s] || {};
              return '<div class="dt-duel__art">' +
                (p.image ? '<img src="' + p.image + '" alt="' + HEROES[s].name + '" loading="lazy">' : '') +
              '</div>';
            }).join('<span class="dt-duel__vs">VS</span>') +
          '</div>' +
          '<div class="dt-duel__body">' +
            '<span class="dt-duel__for">' + d.for + '</span>' +
            '<h4 class="dt-duel__name">' + d.name + '</h4>' +
            '<p class="dt-duel__pair">' + d.heroes.map(function (s) {
              return HEROES[s].name + ' <span class="dt-duel__cx">' + HEROES[s].complexity + '/6</span>';
            }).join(' + ') + '</p>' +
            '<p class="dt-duel__why">' + d.why + '</p>' +
            '<div class="dt-duel__foot">' +
              (ok
                ? '<button type="button" class="dt-btn dt-btn--buy dt-btn--duelBuy" data-duel="' + d.id + '">Aggiungi entrambi — ' + money(total) + '</button>'
                : '<span class="dt-duel__unavail">Uno dei due è esaurito</span>') +
              '<button type="button" class="dt-link dt-linkBtn" data-duel-arena="' + d.id + '">Vedi il pronostico ↓</button>' +
            '</div>' +
          '</div>' +
        '</article>';
      });
      elDuels.innerHTML = html;
    }

    /* ── filtri difficoltà ─────────────────────────────────────── */
    function renderFilters() {
      if (!elFilters) return;
      var tot = Object.keys(HEROES).length;
      var html = '<button type="button" class="dt-chip is-on" data-tier="all">Tutti e ' + tot + '</button>';
      TIERS.forEach(function (t) {
        var n = Object.keys(HEROES).filter(function (s) {
          return HEROES[s].complexity >= t.min && HEROES[s].complexity <= t.max;
        }).length;
        var range = t.min === t.max ? String(t.min) : t.min + '–' + t.max;
        html += '<button type="button" class="dt-chip" data-tier="' + t.id + '"' +
          ' aria-label="' + t.label + ', difficoltà ' + range + ' su 6, ' + n + ' eroi">' +
          '<span class="dt-chip__pips" aria-hidden="true">' + pips(t.max) + '</span>' +
          '<span class="dt-chip__range" aria-hidden="true">' + range + '</span> ' +
          t.label + ' <span class="dt-chip__n">' + n + '</span></button>';
      });
      elFilters.innerHTML = html;
      watchFilterScroll();
    }

    /* Sfumature laterali della striscia filtri.

       Base: se la striscia sborda, sfuma da entrambi i lati. Questo non
       dipende da alcun evento di scorrimento — in certi ambienti l'evento
       'scroll' non viene mai emesso, e la striscia resterebbe bloccata su
       uno stato sbagliato.

       Rifinitura: al PRIMO evento di scorrimento davvero ricevuto passiamo
       alla versione precisa, che toglie la sfumatura dal lato già esaurito. */
    var refreshFilterBar = null;   // impostata da watchFilterScroll

    function watchFilterScroll() {
      if (!elFilters) return;
      var elBarScroll = root.querySelector('[data-dt-filterbar]');
      var thumb = elBarScroll && elBarScroll.firstElementChild;
      var scrollWorks = false;

      var update = function () {
        var max = elFilters.scrollWidth - elFilters.clientWidth;

        // ── indicatore di scorrimento ──
        if (elBarScroll && thumb) {
          if (max <= 2) {
            elBarScroll.classList.remove('is-on');
          } else {
            elBarScroll.classList.add('is-on');
            var ratio = elFilters.clientWidth / elFilters.scrollWidth;   // quanto se ne vede
            var prog = elFilters.scrollLeft / max;                       // 0 → 1
            var w = elBarScroll.clientWidth;
            var tw = Math.max(24, w * ratio);
            thumb.style.width = tw + 'px';
            thumb.style.transform = 'translateX(' + (prog * (w - tw)) + 'px)';
          }
        }

        // ── sfumature laterali ──
        if (max <= 2) {
          elFilters.classList.add('fits');
          elFilters.classList.remove('at-start', 'at-end');
          return;
        }
        elFilters.classList.remove('fits');
        if (!scrollWorks) {
          elFilters.classList.remove('at-start', 'at-end');
          return;
        }
        elFilters.classList.toggle('at-start', elFilters.scrollLeft <= 2);
        elFilters.classList.toggle('at-end', elFilters.scrollLeft >= max - 2);
      };

      elFilters.addEventListener('scroll', function () {
        scrollWorks = true;
        update();
      }, { passive: true });

      // Ripiego: se l'evento 'scroll' non arriva (succede in alcuni contesti),
      // durante il trascinamento seguiamo la posizione con un ciclo di frame,
      // così la barretta si muove comunque. Si spegne appena finito.
      var raf = null, idle = null;

      var stopFollow = function () {
        if (raf !== null) { cancelAnimationFrame(raf); raf = null; }
        if (idle !== null) { clearTimeout(idle); idle = null; }
        update();
      };
      var follow = function () {
        update();
        raf = requestAnimationFrame(follow);
      };
      // Il ciclo si spegne sempre da solo dopo un po' di inattività: 'wheel'
      // non ha un evento di rilascio, quindi senza questo resterebbe acceso.
      var startFollow = function () {
        if (raf === null) raf = requestAnimationFrame(follow);
        if (idle !== null) clearTimeout(idle);
        idle = setTimeout(stopFollow, 1200);
      };

      ['pointerdown', 'touchstart', 'wheel', 'touchmove'].forEach(function (ev) {
        elFilters.addEventListener(ev, startFollow, { passive: true });
      });
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'mouseleave'].forEach(function (ev) {
        elFilters.addEventListener(ev, function () {
          if (idle !== null) clearTimeout(idle);
          idle = setTimeout(stopFollow, 400);
        }, { passive: true });
      });

      window.addEventListener('resize', update);
      // window.resize non scatta quando cambia solo il layout (font caricati,
      // breakpoint, contenuto): osserva direttamente l'elemento.
      if (window.ResizeObserver) new ResizeObserver(update).observe(elFilters);
      else setTimeout(update, 300);

      refreshFilterBar = update;
      update();
    }

    function applyFilter(tierId) {
      activeTier = tierId;
      elFilters.querySelectorAll('[data-tier]').forEach(function (b) {
        var on = b.getAttribute('data-tier') === tierId;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // porta il chip scelto dentro la striscia visibile, senza muovere la pagina
        if (on && b.scrollIntoView) {
          b.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          // lo scorrimento è animato: riallinea la barretta a fine corsa
          if (refreshFilterBar) {
            setTimeout(refreshFilterBar, 60);
            setTimeout(refreshFilterBar, 450);
          }
        }
      });
      root.querySelectorAll('.dt-tier').forEach(function (sec) {
        sec.hidden = !(tierId === 'all' || sec.getAttribute('data-tier') === tierId);
      });
    }

    /* ── render della griglia eroi ─────────────────────────────── */
    function renderRoster() {
      var html = '';
      TIERS.forEach(function (tier) {
        var inTier = Object.keys(HEROES).filter(function (s) {
          var c = HEROES[s].complexity;
          return c >= tier.min && c <= tier.max;
        });
        if (!inTier.length) return;

        html += '<div class="dt-tier" data-tier="' + tier.id + '" id="tier-' + tier.id + '">';
        html += '<div class="dt-tier__head">';
        html += '<div class="dt-tier__pips" aria-hidden="true">' + pips(tier.max) + '</div>';
        html += '<h3 class="dt-tier__label">' + tier.label + '</h3>';
        html += '<span class="dt-tier__range">Difficoltà ' + (tier.min === tier.max ? tier.min : tier.min + '–' + tier.max) + ' su 6</span>';
        html += '</div>';
        html += '<p class="dt-tier__blurb">' + tier.blurb + '</p>';
        html += '<div class="dt-tier__grid">';
        inTier.forEach(function (slug) { html += heroCard(slug); });
        html += '</div></div>';
      });
      elRoster.innerHTML = html;
    }

    function pips(n) {
      var out = '';
      for (var i = 1; i <= 6; i++) {
        out += '<span class="dt-pip' + (i <= n ? ' is-on' : '') + '"></span>';
      }
      return out;
    }

    function heroCard(slug) {
      var h = HEROES[slug];
      var p = PRODUCTS[slug] || {};
      var sold = p.available === false;
      var pre = p.preorder === true;

      var badge = '';
      if (sold) badge = '<span class="dt-badge dt-badge--out">✕ Esaurito</span>';
      else if (pre) badge = '<span class="dt-badge dt-badge--pre">◷ Preordine' + (p.eta ? ' · ' + p.eta : '') + '</span>';

      return '' +
      '<article class="dt-hero' + (sold ? ' is-out' : '') + '" data-hero="' + slug + '">' +
        '<div class="dt-hero__art">' +
          (p.image ? '<img src="' + p.image + '" alt="' + h.name + '" loading="lazy" width="600" height="600">' : '<div class="dt-hero__noart"></div>') +
          badge +
        '</div>' +
        '<div class="dt-hero__body">' +
          '<div class="dt-hero__topline">' +
            '<h4 class="dt-hero__name">' + h.name + '</h4>' +
            '<span class="dt-hero__cx" title="Difficoltà ' + h.complexity + ' su 6">' +
              '<span class="dt-hero__cxPips" aria-hidden="true">' + pips(h.complexity) + '</span>' +
              '<span class="dt-hero__cxNum">' + h.complexity + '/6</span>' +
            '</span>' +
          '</div>' +
          '<p class="dt-hero__epithet">' + h.epithet + '</p>' +
          '<p class="dt-hero__story">' + h.story + '</p>' +
          '<dl class="dt-hero__specs">' +
            '<div><dt>Il suo motore</dt><dd>' + h.engine + '</dd></div>' +
            '<div><dt>Cosa ti fa</dt><dd>' + h.threats.map(function (t) { return '<span class="dt-tok">' + t + '</span>'; }).join('') + '</dd></div>' +
            '<div><dt>Come ci si sente</dt><dd>' + h.feel + '</dd></div>' +
          '</dl>' +
          '<p class="dt-hero__fit"><b>Fa per te se</b> ' + h.forYou + '.<br><b>Lascia perdere se</b> ' + h.notForYou + '.</p>' +
          '<div class="dt-hero__buy">' +
            '<span class="dt-hero__price">' + (p.price != null ? money(p.price) : '—') + '</span>' +
            '<button type="button" class="dt-btn dt-btn--add" data-select="' + slug + '" aria-pressed="false"' + (sold ? ' disabled' : '') + '>' +
              (sold ? 'Esaurito' : '+ Aggiungi') +
            '</button>' +
          '</div>' +
          '<div class="dt-hero__actions">' +
            '<button type="button" class="dt-linkBtn" data-pick="' + slug + '"' + (sold ? ' disabled' : '') + '>⚔ Mettilo in arena</button>' +
            (p.url ? '<a class="dt-link" href="' + p.url + '">Scheda completa</a>' : '') +
          '</div>' +
        '</div>' +
      '</article>';
    }

    /* ── MODAL SCONTRI — flusso completo a step ─────────────────
       step 'pick'    → scegli un eroe (slot a o b)
       step 'verdict' → pronostico + acquisto
       ───────────────────────────────────────────────────────────── */
    var elModal = root.querySelector('[data-dt-modal]');
    var elFab = root.querySelector('[data-dt-fab]');
    var modalStep = null;
    var modalTarget = null;
    var lastFocused = null;

    function openPicker(which) {
      modalStep = 'pick';
      modalTarget = which;
      showModal();
    }

    function openVerdict() {
      if (!slotA || !slotB) return;
      modalStep = 'verdict';
      showModal();
    }

    function showModal() {
      if (!elModal) return;
      if (elModal.hidden) {
        lastFocused = document.activeElement;
        document.body.style.overflow = 'hidden';
      }
      elModal.hidden = false;
      renderModal();
      var f = elModal.querySelector('[data-mo-pick], .dt-mo__x');
      if (f) f.focus();
    }

    function closeModal() {
      if (!elModal || elModal.hidden) return;
      elModal.hidden = true;
      elModal.innerHTML = '';
      document.body.style.overflow = '';
      modalStep = null; modalTarget = null;
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function renderModal() {
      elModal.innerHTML =
        '<div class="dt-mo__backdrop" data-mo-close></div>' +
        '<div class="dt-mo__panel" role="dialog" aria-modal="true" aria-label="Crea il tuo scontro">' +
          (modalStep === 'verdict' ? verdictStep() : pickStep()) +
        '</div>';
    }

    /* ── step 1/2: scelta eroe ─────────────────────────────────── */
    function pickStep() {
      var which = modalTarget;
      var taken = which === 'a' ? slotB : slotA;
      var current = which === 'a' ? slotA : slotB;

      // Lista, non griglia di immagini: l'altezza della riga segue sempre il
      // testo, quindi nomi e difficoltà non possono essere tagliati. Uso div
      // con role=button perché gli stili <button> del tema deformano il layout.
      var grid = Object.keys(HEROES).map(function (slug) {
        var h = HEROES[slug], p = PRODUCTS[slug] || {};
        var isTaken = slug === taken;
        var isCurrent = slug === current;
        var label = h.name + ', difficoltà ' + h.complexity + ' su 6. ' + h.epithet +
                    (isTaken ? ' Già in campo.' : '');
        return '' +
        '<div class="dt-mo__item' + (isCurrent ? ' is-current' : '') + (isTaken ? ' is-taken' : '') + '"' +
          (isTaken ? ' aria-disabled="true"' : ' role="button" tabindex="0" data-mo-pick="' + slug + '"') +
          ' aria-label="' + label + '">' +
          '<span class="dt-mo__thumb">' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="dt-mo__info">' +
            '<span class="dt-mo__name">' + h.name + '</span>' +
            '<span class="dt-mo__ep">' + h.epithet + '</span>' +
          '</span>' +
          '<span class="dt-mo__diff">' +
            (isTaken
              ? '<span class="dt-mo__flag">In campo</span>'
              : isCurrent
                ? '<span class="dt-mo__flag dt-mo__flag--cur">✓ Scelto</span>'
                : '') +
            '<span class="dt-mo__pips" aria-hidden="true">' + pips(h.complexity) + '</span>' +
            '<span class="dt-mo__cx">' + h.complexity + '/6</span>' +
          '</span>' +
        '</div>';
      }).join('');

      var stepNo = which === 'a' ? '1' : '2';
      var other = which === 'a' ? slotB : slotA;

      return '' +
      '<div class="dt-mo__head">' +
        '<div>' +
          '<span class="dt-mo__eyebrow">Passo ' + stepNo + ' di 2</span>' +
          '<h3 class="dt-mo__title">' + (which === 'a' ? 'Chi diventi tu' : 'Chi sfidi') + '</h3>' +
          (other ? '<p class="dt-mo__sub">Contro <b>' + HEROES[other].name + '</b></p>' : '') +
        '</div>' +
        '<button type="button" class="dt-mo__x" data-mo-close aria-label="Chiudi">✕</button>' +
      '</div>' +
      '<div class="dt-mo__grid">' + grid + '</div>' +
      '<div class="dt-mo__foot">' +
        '<button type="button" class="dt-btn dt-btn--ghostSm" data-mo-random>🎲 Sorteggia uno scontro</button>' +
      '</div>';
    }

    /* ── step 3: pronostico + acquisto ─────────────────────────── */
    function verdictStep() {
      var res = getMatchup(slotA, slotB);
      var m = res.data;
      var ha = HEROES[slotA], hb = HEROES[slotB];
      var pa = PRODUCTS[slotA] || {}, pb = PRODUCTS[slotB] || {};

      var sideA = res.flip ? m.b : m.a;
      var sideB = res.flip ? m.a : m.b;

      var total = (pa.price || 0) + (pb.price || 0);
      var buyable = pa.variantId && pb.variantId && pa.available !== false && pb.available !== false;

      return '' +
      '<div class="dt-mo__head">' +
        '<div>' +
          '<span class="dt-mo__eyebrow">Pronostico dello scontro</span>' +
          '<h3 class="dt-mo__title">' + m.title + '</h3>' +
        '</div>' +
        '<button type="button" class="dt-mo__x" data-mo-close aria-label="Chiudi">✕</button>' +
      '</div>' +

      '<div class="dt-mo__body">' +

        '<div class="dt-mo__fighters">' +
          fighter(slotA, 'a') +
          '<span class="dt-mo__vs">VS</span>' +
          fighter(slotB, 'b') +
        '</div>' +

        '<div class="dt-verdict__fav">' +
          '<span class="dt-verdict__favLabel">Chi parte favorito</span>' +
          '<p>' + m.favWhy + '</p>' +
        '</div>' +

        '<div class="dt-verdict__cols">' +
          sideBlock(ha, sideA, m.fav === slotA) +
          sideBlock(hb, sideB, m.fav === slotB) +
        '</div>' +

        '<div class="dt-verdict__turn">' +
          '<span class="dt-verdict__turnLabel">La svolta</span>' +
          '<p>' + m.turn + '</p>' +
        '</div>' +

        '<p class="dt-verdict__tempo"><b>Ritmo:</b> ' + m.tempo + '</p>' +
        (m.note ? '<p class="dt-verdict__note">' + m.note + '</p>' : '') +
        (m.composed ? '<p class="dt-verdict__composed">Lettura generata dai profili dei due eroi. Gli scontri più giocati hanno un\'analisi scritta a mano — provane un altro per vederla.</p>' : '') +

      '</div>' +

      '<div class="dt-mo__foot dt-mo__foot--buy">' +
        (buyable
          ? '<button type="button" class="dt-btn dt-btn--buy dt-btn--modalBuy" data-dt-add>' +
              'Porta questo scontro al tavolo — ' + money(total) +
            '</button>' +
            '<span class="dt-mo__buyNote">Due eroi, una partita completa. Non serve altro per giocare.</span>'
          : '<p class="dt-verdict__unavail">Uno dei due eroi non è disponibile in questo momento. ' +
            (pa.url ? '<a href="' + pa.url + '">' + ha.name + '</a> · ' : '') +
            (pb.url ? '<a href="' + pb.url + '">' + hb.name + '</a>' : '') + '</p>') +
      '</div>';
    }

    function fighter(slug, which) {
      var h = HEROES[slug], p = PRODUCTS[slug] || {};
      return '' +
      '<button type="button" class="dt-mo__fighter" data-mo-open="' + which + '" title="Cambia eroe">' +
        (p.image ? '<img src="' + p.image + '" alt="' + h.name + '">' : '<span class="dt-mo__fighterPh"></span>') +
        '<span class="dt-mo__fighterName">' + h.name + '</span>' +
        '<span class="dt-mo__fighterCx">Difficoltà ' + h.complexity + '/6</span>' +
        '<span class="dt-mo__fighterSwap">Cambia</span>' +
      '</button>';
    }

    function sideBlock(h, side, isFav) {
      return '' +
      '<div class="dt-side' + (isFav ? ' is-fav' : '') + '">' +
        '<div class="dt-side__head">' +
          '<h4>Se giochi ' + h.name + '</h4>' +
          (isFav ? '<span class="dt-side__favTag">▲ Favorito</span>' : '') +
        '</div>' +
        '<p class="dt-side__are">' + h.youAre + '</p>' +
        '<p class="dt-side__fear"><b>Il tuo incubo:</b> ' + side.fear + '</p>' +
        '<p class="dt-side__win"><b>Come vinci:</b> ' + side.win + '</p>' +
      '</div>';
    }

    /* ── stato slot ────────────────────────────────────────────── */
    function setSlot(which, slug) {
      if (which === 'a') { if (slotB === slug) slotB = null; slotA = slug; }
      else              { if (slotA === slug) slotA = null; slotB = slug; }
    }

    function pick(slug) {
      // dalla card eroe: apre il modal già impostato
      if (!slotA || (slotA && slotB)) { slotA = slug; slotB = null; openPicker('b'); }
      else { slotB = slug; openVerdict(); }
    }

    function randomDuel() {
      var keys = Object.keys(HEROES).filter(function (s) {
        return (PRODUCTS[s] || {}).available !== false;
      });
      if (keys.length < 2) return;
      var i = Math.floor(Math.random() * keys.length);
      var j = Math.floor(Math.random() * (keys.length - 1));
      if (j >= i) j++;
      slotA = keys[i]; slotB = keys[j];
      openVerdict();
    }
    /* ── carrello ──────────────────────────────────────────────── */
    function addToCart(slugs, btn, opts) {
      opts = opts || {};
      var items = slugs.map(function (s) {
        var p = PRODUCTS[s] || {};
        return p.variantId ? { id: p.variantId, quantity: 1 } : null;
      }).filter(Boolean);
      if (!items.length) return;

      var original = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Aggiungo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        btn.innerHTML = '✓ Nel carrello';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (opts.goToCart) {
          setTimeout(function () { window.location.href = '/cart'; }, 700);
        } else {
          selected = [];
          setTimeout(function () {
            btn.disabled = false; btn.innerHTML = original;
            renderSelection();
          }, 1200);
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
        alert('Non sono riuscito ad aggiungere al carrello. Riprova.');
      });
    }

    /* ── eventi ────────────────────────────────────────────────── */
    root.addEventListener('click', function (e) {
      // pulsante fisso "Crea il tuo scontro"
      if (e.target.closest('[data-dt-fab]')) {
        if (slotA && slotB) openVerdict(); else openPicker(slotA ? 'b' : 'a');
        return;
      }

      // modal
      var moOpen = e.target.closest('[data-mo-open]');
      if (moOpen) { openPicker(moOpen.getAttribute('data-mo-open')); return; }
      if (e.target.closest('[data-mo-close]')) { closeModal(); return; }
      if (e.target.closest('[data-mo-random]')) { randomDuel(); return; }
      var moPick = e.target.closest('[data-mo-pick]');
      if (moPick && !moPick.disabled) {
        var w = modalTarget;
        setSlot(w, moPick.getAttribute('data-mo-pick'));
        // manca l'avversario → passa al secondo, altrimenti mostra il pronostico
        if (!slotB) openPicker('b');
        else if (!slotA) openPicker('a');
        else openVerdict();
        return;
      }

      // selezione multipla dalla griglia
      var sel = e.target.closest('[data-select]');
      if (sel && !sel.disabled) { toggleSelect(sel.getAttribute('data-select')); return; }

      // barra bundle
      if (e.target.closest('[data-dt-clearsel]')) { selected = []; renderSelection(); return; }
      var addSel = e.target.closest('[data-dt-addsel]');
      if (addSel) { addToCart(selected.slice(), addSel, { goToCart: false }); return; }

      // duelli pronti
      var dBuy = e.target.closest('[data-duel]');
      if (dBuy) {
        var d = DUELS.filter(function (x) { return x.id === dBuy.getAttribute('data-duel'); })[0];
        if (d) addToCart(d.heroes, dBuy, { goToCart: true });
        return;
      }
      var dArena = e.target.closest('[data-duel-arena]');
      if (dArena) {
        var da = DUELS.filter(function (x) { return x.id === dArena.getAttribute('data-duel-arena'); })[0];
        if (da) { slotA = da.heroes[0]; slotB = da.heroes[1]; openVerdict(); }
        return;
      }

      // filtri difficoltà
      var chip = e.target.closest('[data-tier]');
      if (chip && chip.classList.contains('dt-chip')) { applyFilter(chip.getAttribute('data-tier')); return; }

      // "Mettilo in arena" da una card eroe
      var p = e.target.closest('[data-pick]');
      if (p && !p.disabled) { pick(p.getAttribute('data-pick')); return; }

      // acquisto dal pronostico
      var b = e.target.closest('[data-dt-add]');
      if (b) { addToCart([slotA, slotB], b, { goToCart: true }); return; }
    });

    // Tastiera: Esc chiude, Invio/Spazio scelgono l'eroe sotto focus
    document.addEventListener('keydown', function (e) {
      if (!elModal || elModal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        var item = e.target.closest && e.target.closest('[data-mo-pick]');
        if (item) { e.preventDefault(); item.click(); }
      }
    });

    renderFilters();
    renderRoster();
    renderDuels();
    renderSelection();
  }

  document.querySelectorAll('[data-dt-arena]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-dt-arena]').forEach(init);
  });
})();
